import { render } from "./IconAlertTriangleFill.vue?vue&type=template&id=3cac22af"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__